import { render, staticRenderFns } from "./BatchResult.vue?vue&type=template&id=187a4025&scoped=true"
import script from "./BatchResult.vue?vue&type=script&lang=js"
export * from "./BatchResult.vue?vue&type=script&lang=js"
import style0 from "./BatchResult.vue?vue&type=style&index=0&id=187a4025&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187a4025",
  null
  
)

export default component.exports